import { useMutation } from "react-query";
import { uploadFleetVehicles } from "store/api/api";
import { handleAxiosError } from "store/util";
import { MUTATION_KEYS } from "../queryKeys";

const uploadVehiclesToFleet = async (params: {
  fleetId: string;
  file: { name: string; base64str: string };
}) => {
  return await uploadFleetVehicles(params.fleetId, params.file);
};

export function useUploadFleetVehicles() {
  return useMutation(uploadVehiclesToFleet, {
    mutationKey: MUTATION_KEYS.uploadFleetVehicles,

    onError: (err) => {
      handleAxiosError(err);
    },
  });
}
